//General DLS Configuration
export const DLS_ENABLED = 'dls_enabled';
export const DLS_BACKEND_URL = 'dls_backend_url';
export const DLS_TENANT = 'dls_tenant';
export const WTM_ENABLED = 'wtm_enabled';
export const WTM_BACKEND_URL = 'wtm_backend_url';
export const DISCLAIMER_ENABLED = 'disclaimer_enabled';
export const DISCLAIMER_URL = 'disclaimer_url';
export const LABEL_ENABLED = 'label_enabled';
export const LABEL_URL = 'label_url';
export const THUMBNAIL_UPLOAD_MAX_SIZE = 'thumbnail_upload_max_size';

//CosmosDB Configuration
export const COSMOS_DATABASE_SPACE_NAME = 'cosmos_database_space_name';

//UI Styling
export const UI_INCLUIDE_FROK = 'ui_include_frok';
export const STYLE_WORD_BREAK = 'style_word_break';

//Module Configuration
export const MODULE_TEMPLATES = 'module_templates';
export const MODULE_SOFTWARE_PRODUCT = 'module_software_product';
export const MODULE_AUDIT = 'module_audit';
export const MODULE_MALWARE_SCANNER = 'module_malware_scanner';

//Authorization Configuration
export const API_TOKEN_PATH = 'api_token_path'
export const USE_CLIENT_ROLES = 'use_client_roles';
export const DLS_ROLE_LENGTH = 'role_length';
export const PERMISSIONS = 'permissions';
export const ROLE_ADMIN = 'role_admin';
export const ROLE_EDITOR = 'role_editor';
export const ROLE_USER = 'role_admin';

//Access Configuration
export const ROLE_ACCESS_MOBILE_VIEW_ADMIN = 'role_access_mobile_view_admin';
export const ROLE_ACCESS_MOBILE_VIEW_EDITOR = 'role_access_mobile_view_editor';
export const ROLE_ACCESS_MOBILE_VIEW_USER = 'role_access_mobile_view_user';

//Locale Configuration
export const LANGUAGE_ONLY_MODE = 'language_only_mode';
export const SWAP_COUNTRY_LANGUAGE = 'swap_country_language';
export const LOCALE_COUNTRY_DEFAULT = 'locale_country_default';
export const LOCALE_LANGUAGE_DEFAULT = 'locale_language_default';
export const LOCALE_COUNTRIES = 'locale_countries';
export const LOCALE_LANGUAGES = 'locale_languages';
